import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'charities';
let baseUrl = config.apiBaseUrl;

export default {
  getAll(where) {
    let whereString = where ? '?where=' + JSON.stringify(where) : '';
    return axios.get(baseUrl + '/' + restModel + whereString, RequestConfig);
  },

  getById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  createOne(fields) {
    return axios.post(baseUrl + '/' + restModel, fields, RequestConfig);
  },

  update(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, RequestConfig);
  },

  deleteById(id) {
    return axios.delete(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  // Availability Periods
  getAvailabilityPeriods(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id + '/availability-periods', RequestConfig);
  },

  postAvailabilityPeriods(id, data) {
    return axios.post(baseUrl + '/' + restModel + '/' + id + '/availability-periods', data, RequestConfig);
  },

  // Get a charity with the lead contact populated
  getOwnPopulatedById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id + '/populated', RequestConfig);
  },

  // Get connected retailers for the authenticated charity
  getOwnConnectedRetailers() {
    return axios.get(baseUrl + '/' + restModel + '/own-connected-retailers', RequestConfig);
  },

  getCharityVolunteers(charityBranchId) {
    return axios.get(baseUrl + '/' + restModel + '/charity-volunteer-users/' + charityBranchId, RequestConfig);
  }
}
